import { useEffect, useRef, useState } from 'react';

const trustPoints = [
  {
    icon: 'ri-robot-2-line',
    title: 'Entrupy AI 驗真',
    description: '採用國際認證的 AI 儀器，精準識別名牌包真偽，準確率達 99.1%。',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Legit App 技術',
    description: '結合區塊鏈與圖像識別技術，為您的資產建立數位身份證明。',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '中檢標準認證',
    description: '符合台灣權威實驗室標準，提供具法律效力的鑑定證書。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '寶石支持全國複檢',
    description: '支持全國任何權威機構複檢，假一賠三，讓您買得安心。',
  },
];

export default function TrustSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-28 lg:py-36 bg-white overflow-hidden">
      {/* Background Text */}
      <div className="absolute top-8 right-0 pointer-events-none select-none overflow-hidden">
        <span className="block font-heading text-[10rem] lg:text-[18rem] leading-none text-black/[0.02] tracking-wider">
          TRUST
        </span>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-16">
        {/* Header */}
        <div className={`text-center mb-20 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-10 h-px bg-black"></div>
            <span className="text-[11px] font-body font-medium tracking-[0.25em] text-neutral-500 uppercase">
              Why Trust Us
            </span>
            <div className="w-10 h-px bg-black"></div>
          </div>
          <h2 className="font-heading text-5xl lg:text-7xl text-black leading-[0.95] tracking-wide mb-6">
            三重驗證保障
          </h2>
          <p className="font-body text-[14px] text-neutral-600 leading-relaxed max-w-2xl mx-auto">
            結合國際 AI 技術、區塊鏈驗證與台灣權威標準，為您提供最可靠的鑑定服務
          </p>
        </div>

        {/* Trust Points Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustPoints.map((point, index) => (
            <div
              key={index}
              className={`group relative bg-neutral-50 border border-neutral-200 p-8 hover:bg-white hover:border-black transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${300 + index * 150}ms` }}
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-6 bg-black group-hover:bg-neutral-800 transition-colors">
                <i className={`${point.icon} text-3xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="font-heading text-xl text-black mb-3 tracking-wide">
                {point.title}
              </h3>
              <p className="font-body text-[13px] text-neutral-700 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
